import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Unlock } from "lucide-react";

export function UnlockAttendancePermissionCard({ token }) {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    api.post("/attendance-dashboard/unlock-permission/list", { token })
      .then((r) => setRows(r.data.rows || [])).catch(() => setRows([]));
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (u, grant) => {
    try {
      await api.post("/attendance-dashboard/unlock-permission/set",
        { token, mobile: u.mobile, center: u.center, grant });
      toast.success(`Unlock Attendance ${grant ? "granted to" : "revoked for"} ${u.name}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Update failed"); }
  };

  return (
    <Card data-testid="unlock-permission-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Unlock className="w-4 h-4" /> Unlock Attendance permission
        </CardTitle>
        <p className="text-xs text-muted-foreground">
          Super Admin can always unlock. MGT/Admin users can unlock a centre-month only when granted here.
        </p>
      </CardHeader>
      <CardContent className="divide-y">
        {rows.length === 0 && <div className="text-sm text-muted-foreground py-2">No MGT/Admin users found.</div>}
        {rows.map((u) => (
          <div key={`${u.mobile}-${u.center}`} className="flex items-center justify-between py-2 text-sm"
            data-testid={`unlock-perm-row-${u.mobile}`}>
            <span>{u.name} <span className="text-muted-foreground">· {u.center} · {u.mobile}</span></span>
            <Switch checked={!!u.can_unlock_attendance} onCheckedChange={(v) => toggle(u, v)}
              data-testid={`unlock-perm-switch-${u.mobile}`} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
